import { File } from "lucide-react";
import { NotesActivity, ItineraryActivity, SupplierStatus } from "../models/activity.model";
import { BaseActivityCard } from "./BaseActivityCard";
import { ActivityLink } from "./ActivityFields";
import { DocumentationList } from "@/components/ui/documentation-list";

interface NotesCardProps {
  activity: NotesActivity;
  onEdit: (activity: ItineraryActivity) => void;
  onDelete: (activity: ItineraryActivity) => void;
  onDuplicate?: (activity: ItineraryActivity) => void;
  onSaveToLibrary?: (activity: ItineraryActivity) => void;
  onExpand?: () => void;
  isReadOnly?: boolean;
  onDragStart?: (activity: ItineraryActivity) => void;
  onDropBefore?: (sourceActivityId: string, targetActivityId?: string) => void;
  onDragEnd?: () => void;
  isTraveler?: boolean;
  isAdmin?: boolean;
  unsaved?: boolean;
  showSupplierStatus?: boolean;
  onSupplierStatusChange?: (activity: ItineraryActivity, status: SupplierStatus | null) => void;
}

export const NotesCard = ({
  activity,
  onEdit,
  onDelete,
  onDuplicate,
  onSaveToLibrary,
  onExpand,
  isReadOnly = false,
  onDragStart,
  onDropBefore,
  onDragEnd,
  isTraveler = false,
  isAdmin = false,
  unsaved = false,
  showSupplierStatus = false,
  onSupplierStatusChange,
}: NotesCardProps) => {

  const renderAlwaysVisible = () => (
    <>
    </>
  );

  const renderCollapsible = () => (
    <>
      {/* Documentation */}
      <DocumentationList documentation={activity.documentation || []} />

      {/* Link — stessa regola di visibilità delle altre card (mai al viaggiatore) */}
      <ActivityLink link={activity.link} isAdmin={isAdmin} isTraveler={isTraveler} />
    </>
  );

  return (
    <BaseActivityCard
      activity={activity}
      onEdit={onEdit}
      onDelete={onDelete}
      onDuplicate={onDuplicate}
      onSaveToLibrary={onSaveToLibrary}
      onDragStart={onDragStart}
      onDropBefore={onDropBefore}
      onDragEnd={onDragEnd}
      onExpand={onExpand}
      isReadOnly={isReadOnly}
      isTraveler={isTraveler}
      isAdmin={isAdmin}
      unsaved={unsaved}
      showSupplierStatus={showSupplierStatus}
      onSupplierStatusChange={onSupplierStatusChange}
      media={activity.media}
    >
      {{
        alwaysVisible: renderAlwaysVisible(),
        collapsible: renderCollapsible()
      }}
    </BaseActivityCard>
  );
};
